<template>
    <page style="cursor:default; min-height: auto;">
        <data-list ref="list"
                   :plural="$T(plural)"
                   :singular="$T(singular)"
                   :slug="slug"
                   :icon="icon"
                   :model="model"
                   :columns="this[columnsDef]"
                   :row-click="showDetail"
                   :create-route="createRoute"
                   :export-route="user.can_export ? exportRoute : null"
                   :export-stock-orders="user.can_export ? exportStockOrders : null"
                   :export-change-status-route="user.can_export ? exportChangeStatusRoute : null"
                   :export-params="exportParams"
                   :import-route="importRoute"
                   :import-params="importParams"
                   :update-import-route="updateImportRoute"
                   :update-import-params="updateImportParams"
                   :change-order-status-completed-not-returned-route="changeOrderStatusCompletedNotReturnedRoute"
                   :change-order-status-completed-not-returned-params="changeOrderStatusCompletedNotReturnedParams"
                   :updateMetaInfo="updateMetaInfo"
                   :updateUrlPagination="updateUrlPagination"
                   :searchActive="searchActive"
                    />

        <component :is="detailComp" :item="item" :show="modalDetail" @close="modalDetail=false" @updated="refreshList"></component>
    </page>
</template>

<script>
    import dataList from './_list'
    import orderColumns from './orderColumns'
    import orderCoachColumns from './orderCoachColumns'
    import lendingKitColumns from './lendingKitColumns'
    import orderDetail from './_orderDetail'
    import lendingKitDetail from './_lendingKitDetail'
    import stockOrderColumns from './stockOrderColumns';
    import stockMovementColumns from './stockMovementColumns';
    import stockOrderDetail from './courier/stock-order/_stockOrderDetail'
    import orderDunningDetail from "./backoffice/order/orderDunningDetail"
    import orderDunningColumns from "./orderDunningColumns";
    import auditStockOrderColumns from "./auditStockOrderColumns";
    import {mapGetters} from 'vuex';
    import orderHostessesColumns from './orderHostessesColumns';

    export default {
        middleware: 'auth',

        mixins: [orderColumns, lendingKitColumns, stockOrderColumns, stockMovementColumns, orderCoachColumns, orderDunningColumns, auditStockOrderColumns, orderHostessesColumns],

        components: {
            dataList,
            orderDetail,
            lendingKitDetail,
            stockOrderDetail,
            orderDunningDetail
        },

        props: {
            slug: String,
            singular: String,
            plural: String,
            icon: String,
            model: {
              type: String,
              required: false
            },
            columnsDef: String,
            detailComp: String,
            createRoute: String,
            exportRoute: String,
            exportStockOrders: String,
            exportChangeStatusRoute: String,
            updateMetaInfo: {
                type: Boolean,
                default: true
            },
            updateUrlPagination: {
                type: Boolean,
                default: true
            },            
            exportParams: {
                type: Object,
                default:() => {}
            },
            importRoute: String,
            importParams: {
                type: Object,
                default:() => {}
            },
            updateImportRoute: String,
            updateImportParams: {
                type: Object,
                default:() => {}
            },
            changeOrderStatusCompletedNotReturnedParams: {
                type: Object,
                default:() => {}
            },
            changeOrderStatusCompletedNotReturnedRoute: String,
            searchActive: Boolean
        },

        data() {
            return {
                modalDetail: false,
                item: {}
            }
        },

        methods: {
            showDetail(item) {
                  this.item = item
                  this.modalDetail = true
            },

            refreshList() {
                this.$refs.list.refreshRows()
            },
        },

        computed: {
            ...mapGetters({
                user: 'auth/user'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/list.vue